import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import ArticlesList from "../../Components/Articles/ArticlesList";
import Loading from "../../Components/Common/Loading";
import PageCard from "../../Components/PageCard/PageCard";
import { getAllArticles } from "../../REDUX/actions/articles";
import { getPageByName } from "../../REDUX/actions/pages";

const EmploiView = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPageByName("Page nous rejoindre"));
    dispatch(getAllArticles("", 1)); // eslint-disable-next-line
  }, []);

  const { pagesLoading, ActivePage } = useSelector(
    (state) => state.pagesReducer
  );
  const { articles, articlesLoading } = useSelector(
    (state) => state.articlesReducer
  );

  return pagesLoading || !ActivePage || !articles ? (
    <Loading />
  ) : (
    <>
      <PageCard page={ActivePage} collapsed />
      <ArticlesList
        title="Liste des offres d'emploi"
        articlesLoading={articlesLoading}
        articles={articles.filter((article) => article.attributes.type === 1)}
        type={1}
        buttonText="Ajouter une offre d'emploi"
      />
    </>
  );
};

export default EmploiView;
